import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CompanyTeams extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/company-teams'
    }
}

export default new CompanyTeams()
